import React, { useEffect, useState } from "react";
import {
  Input,
  Label,
  Dropdown,
  Option,
  Button,
  Field,
  Switch
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../CSS/AgentProfileForm.css";
import { REGIONS } from '../GenericComponent/GenericData/region'
import { Add20Filled, Edit20Filled } from "@fluentui/react-icons";
import InfoButton from "../GenericComponent/InfoButton";
const AgentProfileForm = (props) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  
  // Get callflows from Redux
  const callFlows = useSelector(state => state.reducer.CALL_FLOWS) || {};
  
  // Convert callflows object/array to array format
  const getCallFlowsArray = () => {
    if (!callFlows) return [];
    
    // If it's already an array
    if (Array.isArray(callFlows)) {
      return callFlows;
    }
    
    // If it's an object, convert to array
    if (typeof callFlows === 'object') {
      return Object.values(callFlows);
    }
    
    return [];
  };
  
  const callFlowsArray = getCallFlowsArray();
  
  // Convert OBO object to array of selected flow IDs
  const getSelectedFlowIds = () => {
    if (!props.profile?.OBO) return [];
    const selectedIds = Object.keys(props.profile.OBO);
    return selectedIds;
  };
  
  const selectedFlowIds = getSelectedFlowIds();
  
  // Debug: log callflows to see structure
  useEffect(() => {
  }, [props.profile?.OBO]);
  
  // Handle OBO selection change
  const handleOBOChange = (_, data) => {
    const selectedIds = data.selectedOptions;
    
    // Build new OBO object
    const newOBO = {};
    selectedIds.forEach(flowId => {
      const flow = callFlowsArray.find(f => f.id === flowId);
      if (flow) {
        newOBO[flowId] = {
          displayName: flow.FLOW_NAME || flow.displayName,
        };
      }
    });
    
    props.setProfile({
      ...props.profile,
      OBO: newOBO
    });
  };

  // ✅ Validation
  const validateForm = () => {
    const newErrors = {};

    if (!props.profile?.displayName)
      newErrors.displayName = t("THIS_FIELD_IS_REQUIRED");
    if (!props.profile?.region)
      newErrors.region = t("THIS_FIELD_IS_REQUIRED");

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    props.setFormValid?.(isValid);
  };
  useEffect(() => {
    validateForm();
  }, [props.profile?.displayName, props.profile?.region]);
  return (
    <div className="agent-profile-form-root">
      {/* --- Display Name --- */}
      <div className="agent-profile-form-group">
        <Field
          label={t("AGENT_PROFILE_NAME")}
          className="agent-profile-form-field"
          required
          validationState={errors.displayName ? "error" : "none"}
          validationMessage={errors.displayName}
        >
          <Input
            className="agent-profile-form-dropdown"
            placeholder={t("ENTER_NAME")}
            value={props.profile?.displayName || ""}
            onChange={(e, data) =>
              props.setProfile({
                ...props.profile,
                displayName: data.value,
              })
            }
          />
        </Field>
      </div>

      {/* --- Region --- */}
      <div className="agent-profile-form-group">
        <Field
          label={t("REGION")}
          className="agent-profile-form-field"
          required
          validationState={errors.region ? "error" : "none"}
          validationMessage={errors.region}
        >
          <Dropdown
            clearable
            className="agent-profile-form-dropdown"
            placeholder={t("SELECT_REGION")}
            value={props.profile?.region || ""}
            onOptionSelect={(_, data) => {
              props.setProfile({
                ...props.profile,
                region: data.optionValue,
              });
            }}
          >
            {REGIONS.map((region, index) => (
              <Option key={index} value={region.value}>
                {region.header}
              </Option>
            ))}
          </Dropdown>
        </Field>
      </div>

      {/* --- Requeue Unanswered Transfered Call --- */}
      <div className="agent-profile-form-checkbox-row">
        <Label weight="semibold">
          {t("REQUEUE_UNASSWERED_TRANSFERED_CALL")}
          <InfoButton infoKey="REQUEUE_UNASSWERED_TRANSFERED_CALL" category="AGENTS" />
        </Label>
        <Switch
          checked={props?.profile?.RequeueUnansweredTransferedCall || false}
          onChange={(e, data) => {
            props.setProfile({
              ...props.profile,
              RequeueUnansweredTransferedCall: data.checked,
            });
          }}
        />
      </div>

      {/* --- Call On Behalf Of (OBO) --- */}
      <div className="agent-profile-form-group">
        <Field
          label={t("CALL_ON_BEHALF_OF")}
          className="agent-profile-form-field obo-div"
          hint={t("SELECT_CALLFLOWS_FOR_OBO")}
        >
          <Dropdown
            multiselect
            className="agent-profile-form-dropdown "
            placeholder={t("SELECT_CALLFLOWS")}
            value={selectedFlowIds.map(id => {
              const flow = callFlowsArray.find(f => f.id === id);
              return flow ? flow.displayName : id;
            }).join(', ')}
            selectedOptions={selectedFlowIds}
            onOptionSelect={handleOBOChange}
          >
            {callFlowsArray.length > 0 ? (
              callFlowsArray.map((flow) =>{ 
                return(
                <Option key={flow.id} value={flow.id}>
                  {flow.displayName}
                </Option>
              )})
            ) : (
              <Option disabled value="">
                {t("NO_CALLFLOWS_AVAILABLE")}
              </Option>
            )}
          </Dropdown>
        </Field>
      </div>
    </div>
  );
};

export default AgentProfileForm;
